import { RouteType } from "../../../types/RouteType";

const qcDrawingViewerRoute: RouteType = {
  name: "QC Drawing Viewer",
  path: "/qc/drawings",
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./QCDrawingViewer.Header"),
      title: "QC Drawings",
      color: "primary",
    },
    body: {
      component: () => import("./QCDrawingViewer.Body"),
      grayBackground: true,
    },
  },
  group: "Quality Control",
  requiresAuth: true,
  requiresPermission: false,

  beforeEnter: async () => {
    return true;
  },

  dialogs: [],
};

export default qcDrawingViewerRoute;
